<template>
  <a
    v-if="visible"
    class="chat-ball"
    @click="handleOpenChat"
  >
    <span
      v-if="newMessages"
      class="new-messages"
    >{{ newMessages }}</span>

    <img
      width="50"
      height="50"
      src="./images/chat.png"
      alt="Chat"
    >

    <img
      class="btn-close"
      src="./images/close@2x.png"
      width="12"
      height="12"
      @click.stop="handleClose"
    >
  </a>
</template>

<script>
import { storeToRefs } from 'pinia'
import { openDialog } from '@ms/ui/dialog'
import chat from './sdk.js'
import { useChatBall } from './useChatBall.js'

// 2小时自动关闭
const duration = 2 * 3600 * 1000

export default {
  setup() {
    const chatBallStore = useChatBall()
    const { visible, newMessages } = storeToRefs(chatBallStore)
    const { toggleVisible } = chatBallStore

    return {
      visible,
      toggleVisible,
      newMessages
    }
  },
  mounted() {
    this.timeToHide()
  },
  methods: {
    timeToHide() {
      this._timer && clearInterval(this._timer)
      const startTime = Date.now()
      this._timer = setInterval(() => {
        const diffTime = Date.now() - startTime
        if (diffTime >= duration) {
          chat.isChatting() && chat.end().close()
          clearInterval(this._timer)
        }
      }, 1000)
    },
    handleOpenChat() {
      chat.open()
      clearInterval(this._timer)
    },
    handleClose() {
      openDialog({
        message: 'Are you sure you want to end this conversation?',
        showClose: true,
        confirmButtonText: 'End',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          chat.end().close()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.chat-ball {
  position: fixed;
  z-index: 9;
  right: 12px;
  bottom: 214px;
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;

  .new-messages {
    position: absolute;
    top: 0;
    left: 0;
    min-width: 14px;
    height: 14px;
    box-sizing: border-box;
    padding: 0 5px 0 4px;
    border-radius: 7px;
    background: #f00;
    color: #fff;
    font-size: 9px;
    line-height: 14px;
    text-align: center;
  }

  .btn-close {
    position: absolute;
    top: -2px;
    right: -2px;
  }
}

.page-jackpotHome ~ .chat-ball {
  bottom: 141px;
}

.chat-ball.level-up {
  z-index: 10000;
}
</style>
